<ng-container thr-parent-form>
    <mat-radio-group name="signatory" [(ngModel)]="contract.addressClientId" [required]="true" [disabled]="isDisabled">
        <table class="table participants">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ 'sign.name-surname-and-document' | translate }}</th>
                    <th class="d-none d-md-table-cell">
                        {{ 'sign.phone-and-email' | translate }}
                    </th>
                    <th class="text-right d-none d-md-table-cell">
                        {{ 'sign.appropriateness-profile' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-template ngFor let-participant [ngForOf]="participants" let-i="index">
                    <ng-container *ngIf="participant.type === ClientType.NATURAL_PERSON">
                        <tr>
                            <td class="text-center">
                                <mat-radio-button
                                    [name]="'participant' + i"
                                    color="blue-gray"
                                    [value]="participant.id.value"
                                ></mat-radio-button>
                            </td>
                            <td>
                                <strong>{{ participant.name }}</strong
                                >&nbsp;<strong>{{ participant.surname }}</strong
                                ><br />
                                <strong>{{ participant.docId }}</strong>
                            </td>
                            <td class="d-none d-md-table-cell">
                                <strong>{{ participant.phone }}</strong
                                ><br />
                                <strong>{{ participant.email }}</strong>
                            </td>
                            <td class="text-right d-none d-md-table-cell">
                                <strong class="text-uppercase text-blue" *ngIf="participant.mifidCompetenceName">
                                    {{ participant.mifidCompetenceName }}
                                </strong>
                                <strong class="text-uppercase text-blue" *ngIf="!participant.mifidCompetenceName">
                                    {{ 'sign.appropriateness-profile-level.none' | translate }}
                                </strong>
                            </td>
                        </tr>
                    </ng-container>
                </ng-template>
            </tbody>
        </table>
    </mat-radio-group>
</ng-container>
